import { ThemeProvider } from 'styled-components'

import { ProgressBarFiller, ProgressBarContainer, ServiceHeader, ServiceInfo } from '../styles'
import { iconsMap } from '../config'
import { Service } from '../types'
import * as Styles from './styles'

type ModalSectionProps = {
  sectionTitle: string
  services?: Service[]
}

export const ModalSection = ({ sectionTitle, services }: ModalSectionProps) => {
  return (
    <Styles.SectionContainer>
      <Styles.SectionTitle>{sectionTitle}</Styles.SectionTitle>
      <Styles.SectionContent>
        {services?.map((service: Service) => {
          const Icon = iconsMap[service.icon ?? '_']
          return (
            <ThemeProvider key={service.id} theme={service.theme}>
              <Styles.ListItem>
                <Icon alt={service.title} />
                <ServiceInfo>
                  <ServiceHeader>
                    <span>{service.title}</span>
                    <span>{service.progress}%</span>
                  </ServiceHeader>
                  <ProgressBarContainer isActive={false}>
                    <ProgressBarFiller progress={service.progress} />
                  </ProgressBarContainer>
                </ServiceInfo>
              </Styles.ListItem>
            </ThemeProvider>
          )
        })}
      </Styles.SectionContent>
    </Styles.SectionContainer>
  )
}
